import React, { useEffect, useState } from 'react'
import { useAuth } from '../../hooks/useAuth'

const Switch = ({
	keyPath,
	formState,
	setFormState,
	name,
	onChangePrio,
	checkedPrio,
	disabledPrio,
}: {
	[key: string]: any
	className?: string
	keyPath?: any[]
	formState?: any
	setFormState?: Function
	name?: string
	onChangePrio?: (newValue: boolean) => void
	checkedPrio?: Boolean
	disabledPrio?: Boolean
}) => {
	const auth = useAuth()
	const initValue: any = auth.userDTO?.teams
	const valueFromKeyPath = keyPath?.reduce((acc, key) => acc?.[key], initValue)
	const o = useAuth().userDTO?.teams?.[keyPath ? (keyPath[0] as string) : '']

	let value: any
	if (formState && name) {
		value = formState[name]
	} else if (keyPath) {
		value = valueFromKeyPath
	}

	const [isOn, setIsOn] = useState<boolean | undefined>(undefined)

	useEffect(() => {
		setIsOn(checkedPrio ?? value ?? false)
	}, [checkedPrio, value])

	const handleClick: React.MouseEventHandler<HTMLButtonElement> = () => {
		if (
			disabledPrio != undefined
				? disabledPrio.valueOf()
				: o && o?.scope?.range != 'all' && !auth?.userDTO?.isTikexAdmin
		) {
		} else {
			setIsOn(!isOn)
			if (onChangePrio) {
				onChangePrio(!isOn)
			} else if (formState && setFormState && name) {
				setFormState({
					...formState,
					[name]: !isOn,
				})
			} else {
				auth.updateClientAndServer({
					keyPath: keyPath!,
					value: !isOn,
					operation: 'setValue',
				})
			}
		}
	}

	return isOn == undefined ? (
		<></>
	) : (
		<button
			className={`toggle-button ${isOn ? 'on' : 'off'}`}
			onClick={handleClick}
		>
			<div className="toggle-button-inner">
				<div className="toggle-button-circle"></div>
			</div>
		</button>
	)
}

export default Switch
